import { render, staticRenderFns } from "./pill-cta.vue?vue&type=template&id=1be45026&scoped=true&lang=pug&"
import script from "./pill-cta.vue?vue&type=script&lang=js&"
export * from "./pill-cta.vue?vue&type=script&lang=js&"
import style0 from "./pill-cta.vue?vue&type=style&index=0&id=1be45026&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be45026",
  null
  
)

export default component.exports